import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./SpeakerDistributionModal.module.scss";
import { messages } from "../Case1TechnicalPov.messages";
import { useUi } from "@jelly/lesson";

const BIO_SLIDES_DATA = [
  {
    title: messages.modalSpeakerDistributionConceptTitle,
    content: messages.modalSpeakerDistributionConceptDescription,
  },
  {
    title: messages.modalSpeakerDistributionDesignTitle,
    content: messages.modalSpeakerDistributionDesignDescription,
    linkTitle: messages.modalSpeakerDistributionDesignLinkTitle,
    href: messages.modalSpeakerDistributionDesignHref,
  },
  {
    title: messages.modalSpeakerDistributionSelectionTitle,
    content: messages.modalSpeakerDistributionSelectionDescription,
  },
];

type SpeakerDistributionModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const SpeakerDistributionModal: React.FC<SpeakerDistributionModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  const slides = BIO_SLIDES_DATA.map((data, index) => {
    return (
      <div key={index} className={styles.slide}>
        <div className={styles.title}>{formatMessage(data.title)}</div>
        <div className={styles.content}>{formatMessage(data.content)}</div>
        {data.href && (
          <div className={styles.link}>
            <ui.Button
              size="small"
              shape={"normal"}
              theme={"primary"}
              onClick={() => window.open(formatMessage(data.href))}
            >
              {formatMessage(data.linkTitle)}
            </ui.Button>
          </div>
        )}
      </div>
    );
  });

  return <CarouselModal {...props}>{slides}</CarouselModal>;
};

//TODO: override scrollbars colors
